






























import Vue from 'vue'
import { Prop, Component, Watch } from 'vue-property-decorator'
import { resetPasswordConfirm } from '~/api-shared/auth'
import { ModalStore, IModalParams, ModalType } from '~/store/modal'
import { prettifyApiError } from '~/services/prettify-api-error'

@Component
export default class PasswordResetPage extends Vue {
    @Prop() uidb64!: string
    @Prop() token!: string

    newPassword1 = ''
    newPassword2 = ''
    error = ''
    step = 1

    @ModalStore.Mutation('SET_ACTIVE_MODAL') SET_ACTIVE_MODAL: (IModalParams: IModalParams) => void

    async resetPasswordConfirm() {
        const dispatchParams = { uid: this.uidb64, token: this.token, new_password1: this.newPassword1, new_password2: this.newPassword2 }
        try {
            await resetPasswordConfirm(dispatchParams)
            this.step++
        } catch (err) {
            this.error = prettifyApiError(err)
        }
    }

    validateFields() {
        this.$validator.validateAll().then(result => {
            if (result) this.resetPasswordConfirm()
        })
    }
}
